module.exports = __webpack_public_path__ + "img/sync.a83f68c1.svg";